<script >
import {blurRule} from "@/untils/common";
import {sendSmsCode} from "@/lib/request";
export default {
  name:'register',
  data(){
    return{
      url_openid:'',
      year:null,
      activeTab:0,
      siteId:'',
      name:'',
      radio:'0',
      age:'',
      phone:'',
      // idCard:'',
      code:'',
      disable:false,
      count:0,
      timer: null,
    }
  },
  methods:{
    log(){
      this.$router.push({path: '/login', query: {openid:this.url_openid}});
    },
    getPhoneCode(){
      let self = this;
      if(self.phone===''){
        self.$toast('请输入手机号码');
        return false;
      }else if (!blurRule(self.phone, {name: 'phone'})) {
        return false;
      }else{
        sendSmsCode({ phonenumber: this.phone }).then(res => {
          if (res.data.code === 200) {
            self.disable = true;
            const TIME_COUNT = 60;
            if (!self.timer) {
              self.count = TIME_COUNT;
              self.timer = setInterval(() => {
                if (self.count > 0 && self.count <= TIME_COUNT) {
                  self.count--;
                } else {
                  clearInterval(self.timer);
                  self.timer = null;
                  self.disable = false;
                }
              }, 1000)
            }
            this.$toast.success(res.data.msg)
          } else {
            // this.timeCount = 0;
            this.$toast.fail(res.data.msg)
          }
        }).catch(() => {
          // this.timeCount = 0;
        });
      }
    },
    login(){
      if(this.siteId===''){
        this.$toast('请输入网点编号');
        return false;
      }else if(this.siteId.length<8){
        this.$toast('请输入正确的网点编号');
        return false;
      }else if(this.name===''){
        this.$toast('请输入您的姓名');
        return false;
      }else if (!blurRule(this.name, {name: 'name'})) {
        return false;
      }
      // else if(this.idCard===''){
      //   this.$toast('请输入您的身份证号');
      //   return false;
      // }
      // else if (!blurRule(this.idCard, {name: 'idCard'})) {
      //   return false;
      // }
      else if(this.age===''){
        this.$toast('请输入您的年龄');
        return false;
      }else if(this.age<18){
        this.$toast('年龄不得小于18岁');
        return false;
      }else if(this.phone===''){
        this.$toast('请输入您的手机号码');
        return false;
      }else if (!blurRule(this.phone, {name: 'phone'})) {
        return false;
      }else if(this.code===''){
        this.$toast('请输入短信验证码');
        return false;
      }
      // 根据身份证号、手机号提交登陆接口
      this.$http.salespersonInfo_register({
        "branchId": this.siteId,
        "gender": this.radio,
        "name": this.name,
        "age": this.age,
        // "idCard": this.idCard,
        "contact": this.phone,
        "code": this.code,
      }).then((res)=> {
        if (res) {
          if (res.code===200) {
            this.$toast(`${res.msg},请耐心等待网点代销者审核`, {
              duration: 10000 // 设置 Toast 显示时间为 2000 毫秒（2秒）
            });
            setTimeout(()=>{
              this.log();
            },3000)
          }else{
            this.$toast(res.msg);
            return false;
          }
        }
      });
    },
    getLocation(){
      if(this.url_openid){
        this.$router.push({path: '/login', query: {openid:this.url_openid}});
      }
    },
  },
  created(){
    this.url_openid = this.$route.query.openid;
    this.year = new Date().getFullYear();
  }
}
</script>

<template>
  <div class="login">
    <div class="login-header">
      <div class="header-title">西藏福彩网点管理系统</div>
    </div>
    <div class="content">
      <div class="login-card">
        <div class="welcome-text">
          <div class="welcome-title">销售员注册</div>
          <div class="welcome-subtitle">请完善以下信息进行注册</div>
        </div>

        <div class="form-group">
          <label class="form-label">网点编号</label>
          <input type="number" class="form-input" v-model="siteId" placeholder="请输入网点编号" />
        </div>

        <div class="form-group">
          <label class="form-label">姓名</label>
          <input type="text" class="form-input" v-model="name" placeholder="请输入姓名" />
        </div>

        <div class="form-group">
          <label class="form-label">性别</label>
          <van-radio-group direction="horizontal" v-model="radio">
            <van-radio name="0">男</van-radio>
            <van-radio name="1">女</van-radio>
          </van-radio-group>
        </div>
<!--        <div class="form-group">-->
<!--          <label class="form-label">身份证号</label>-->
<!--          <input type="text" class="form-input" v-model="idCard" placeholder="请输入身份证号" />-->
<!--        </div>-->
        <div class="form-group">
          <label class="form-label">年龄</label>
          <input type="number" class="form-input" v-model="age" placeholder="请输入年龄" min="18" max="65" />
        </div>
        <div class="form-group">
          <label class="form-label">手机号码</label>
          <input type="tel" class="form-input" v-model="phone" placeholder="请输入手机号码" maxlength="11" />
        </div>

        <div class="form-group">
          <label class="form-label">验证码</label>
          <div class="verification-group">
            <input type="number" class="form-input verification-input" v-model="code" placeholder="请输入验证码" maxlength="6" />
            <button class="verification-button" :class="disable?'disabled':''">
              <span v-show="disable">{{count}}s后重新获取</span>
              <span v-show="!disable" @click="getPhoneCode">获取验证码</span>
            </button>
          </div>
        </div>
        <button class="login-button" @click="login()">提交注册</button>
        <div class="registration-link">
          已有账号？<a @click="getLocation">去登录</a>
        </div>
      </div>
    </div>
    <div class="login-footer">
      版权所有 © {{ year }} 西藏自治区福利彩票发行中心
    </div>
  </div>
</template>

<style scoped lang="scss">
.line{
  width: 100%;
  height: 20px;
  border-top: 1px solid var(--border-color);
}
.login{
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.login-header {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  color: white;
  padding: 23px;
  text-align: center;
  box-shadow: var(--shadow);
}

.header-title {
  font-size: 32px;
  font-weight: 600;
}

.content {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-card {
  background: white;
  border-radius: var(--radius-md);
  padding: 24px;
  width: 100%;
  box-shadow: var(--shadow);
}

.welcome-text {
  text-align: center;
  margin-bottom: 24px;
}

.welcome-title {
  font-size: 44px;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 8px;
}

.welcome-subtitle {
  font-size: 28px;
  color: var(--text-secondary);
}

.form-group {
  background: white;
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 28px;
  margin-bottom: 0;
  color: var(--text-secondary);

}

.form-input {
  width: 100%;
  padding:20px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 28px;
  background-color: #f9f9f9;
}

.verification-group {
  display: flex;
  gap: 12px;
}

.verification-input {
  flex: 1;
}

.verification-button {
  width: 220px;
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  border-radius: var(--radius-sm);
  font-size: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.verification-button:active {
  background-color: #fff8f8;
}

.verification-button.disabled {
  border-color: var(--text-light);
  color: var(--text-light);
  cursor: not-allowed;
}

.login-button {
  width: 100%;
  padding: 20px;
  background: var(--primary-color);
  border: none;
  border-radius: var(--radius-sm);
  color: white;
  font-size: 28px;
  font-weight: 500;
  margin-top: 24px;
  cursor: pointer;
  transition: all 0.2s;
}

.login-button:hover {
  background: var(--primary-dark);
}

.login-button:active {
  transform: translateY(1px);
}

.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0,0,0,0.75);
  color: white;
  padding: 12px 24px;
  border-radius: 100px;
  font-size: 28px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s;
}

.toast.show {
  opacity: 1;
}

.login-footer {
  text-align: center;
  padding: 16px;
  color: var(--text-light);
  font-size: 28px;
}
.registration-link {
  text-align: center;
  margin: 36px 0 10px;
  color: var(--text-secondary);
}

.registration-link a {
  color: var(--primary-color);
  text-decoration: none;
}
</style>